import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import flow from 'lodash/flow'
import { withRouter } from 'react-router'
import { Navbar, Nav, NavItem } from 'react-bootstrap'
import { PowerOff } from 'styled-icons/fa-solid/PowerOff'
import Alert from 'react-s-alert'
import { NavSetup, Language, NavNotice, NavSearch, NavTools } from '.'
import { ExclamationTriangle } from 'styled-icons/fa-solid/ExclamationTriangle'


class MainNav extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      logo: 'operator-logo.png'
    }
  }

  componentDidMount = () => {
    const { href } = window.location
    if (href) {
      if (href.indexOf('enerble') !== -1 ) {
        this.setState({logo: 'enerble.png'})
      } else if (href.indexOf('vpplab') !== -1) {
        this.setState({logo: 'vpplab.png'})
      } else if (href.indexOf('localhost') !== -1) {
        this.setState({logo: 'vpplab.png'})
      }
    }
  }
  componentWillUnmount = () => Alert.closeAll()

  onSelect = sel => sel === 'logout' && this.props.history.push('/logout')
/*
  onSelect = (sel) => {
    if (sel === 'logout') this.props.history.push('/logout')
  }

  search = v => Alert.info(<span><ExclamationTriangle size={14}/> Under Construction !!</span>)
*/
  render() {
    if (this.props.history.location.pathname.indexOf('/login') !== -1) return null
    const { user } = this.props

    return (
      <Navbar bsStyle='inverse' className='px-navbar' fluid>
        <Navbar.Header>
          <Navbar.Brand>
            <a href='/Dashboard' style={{width: 150, height: 48}}>
              <img src={`images/${this.state.logo}`} height={28} alt='operator' style={{margin: '10px auto'}} />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <NavSetup {...this.props} />
            <NavTools {...this.props} />
          </Nav>
          <Nav onSelect={this.onSelect} pullRight>
            <NavNotice {...this.props} />
{/*
            <NavSearch onSearch={this.search}/>
            <Language lang={user.lang} />
*/}
            <NavItem eventKey='user'>{user.name}</NavItem>
            <NavItem eventKey='logout'><PowerOff size={14}/></NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}

MainNav.propTypes = {
  strings: PropTypes.object,
  user: PropTypes.object,
  logout: PropTypes.func,
}

MainNav.defaultProps = {
  logout: noop,
}

const decorators = flow([
  withRouter
])

export default decorators(MainNav)



// WEBPACK FOOTER //
// ./src/components/nav/MainNav.js